export default __webpack_public_path__ + "static/project-list-361d0355dc5d82a78973d0fb284b27f9.png";